import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, apiError } from "@/admin/adminApi";
import { card, Pill } from "@/admin/ui";

export default function RegistrationSwitch() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.get("/admin/settings").then((r) => setSettings(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  const toggle = async () => {
    setSaving(true);
    try {
      const { data } = await adminApi.put("/admin/settings", { registration_enabled: !settings.registration_enabled });
      setSettings(data);
      toast.success(data.registration_enabled ? "A nyilvános jelentkezés megnyitva." : "A nyilvános jelentkezés lezárva.");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  if (!settings) return null;
  const on = settings.registration_enabled;
  return (
    <section className={`${card} px-6 md:px-8 py-6 flex flex-col md:flex-row md:items-center gap-5 justify-between`} data-testid="registration-switch">
      <div className="space-y-2.5">
        <div className="flex items-center gap-3 flex-wrap">
          <p className="font-serif-display text-[22px] text-graphite">Nyilvános jelentkezés</p>
          <Pill tone={on ? "green" : "muted"} testId="registration-switch-state">{on ? "Nyitva" : "Zárva"}</Pill>
        </div>
        <p className="font-body text-[13.5px] text-graphite-soft max-w-2xl">
          Nyitott állapotban az „Aktuális programok” oldalon a látogatók a nyitott, szabad hellyel rendelkező időpontokra jelentkezhetnek.
        </p>
        <p className="font-body text-[13px]" data-testid="registration-email-state">
          Automatikus e-mailek:{" "}
          {settings.emails_enabled
            ? <span className="text-[#4D6B3C]">bekapcsolva</span>
            : <span className="text-gold">még nincsenek bekapcsolva — a jelentkező a képernyőn kap visszaigazolást, a jelentkezés itt jelenik meg.</span>}
        </p>
      </div>
      <button type="button" onClick={toggle} disabled={saving} data-testid="registration-switch-toggle"
        className={on ? "inline-flex items-center justify-center px-6 py-3 border border-[#9A3B2E] text-[#9A3B2E] text-[11.5px] uppercase font-body tracking-[0.2em] hover:bg-[#9A3B2E] hover:text-white transition-colors duration-200" : "cta-graphite inline-flex items-center justify-center px-6 py-3 text-[11.5px] uppercase font-body font-medium tracking-[0.2em]"}>
        {on ? "Jelentkezés lezárása" : "Jelentkezés megnyitása"}
      </button>
    </section>
  );
}
